import {b1, b2, b3, p1, p2, p3, p4, instagram, facebook, twitter} from "../assets";

export const navlinks = [
    {
        id: "home",
        title: "Home"
    },
    {
        id: "blog",
        title: "Blog"
    },
    {
        id: "menu",
        title: "Menu"
    },
    {
        id: "about",
        title: "About Us"
    },
    {
        id: "contact",
        title: "Contact Us"
    },
];

export const menu = [
    {
        id: "menu-1",
        img: p1,
        title: "PIZZA CHICKEN FAJITA",
        content: "$5.00",
    },
    {
        id: "menu-2",
        img: p2,
        title: "ZINGER BURGERS",
        content: "$10.00",
    },
    {
        id: "menu-3",
        img: p3,
        title: "HOTS WINGS",
        content: "$2.00",
    },
    {
        id: "menu-4",
        img: p4,
        title: "CHECKEN PASTA",
        content: "$8.00",
    },
];

export const events = [
    {
        id: "event-1",
        img: b1,
        name: "ABOUT 11 MONTHS AGO",
        title: "HAPPY BIRTHDAY EVENTS",
        content: "A BIRTHDAY IS THE ANNIVERSARY OF THE BIRTH OF A PERSON OR FIGURATIVELY OF AN INSTITUTION. BIRTHDAYS OF PEOPLE CELEBRATED IN NUMEROUS CULTURES, OFTEN BIRTHDAY",
        linkname: "LEARN MORE",
    },
    {
        id: "event-2",
        img: b2,
        name: "ABOUT A YEARS AGO",
        title: "FAMILY PARTY EVENTS",
        content: "WE WILL BE CLOSED THURSDAY, NOVEMBER 25TH - SUNDAY,NOVEMBER 28TH. WE WILL REOPEN REGULAR BUSINESS HOURS ON MONDAY, NOVEMBER 29TH. HAVE A HAPPY THANK",
        linkname: "LEARN MORE",
    },
    {
        id: "event-3",
        img: b3,
        name: "ABOUT 1 MONTHS AGO",
        title: "PIZZA REMOTE LUNCH",
        content: "ONE OF THE MOST STRAIGHTFORWARD ONLINE CORPORATE PIZZA PARTY IDEAS IS TO HOLD A REMOTE LUNC OR DINNER PARTY FOR TEAMMATES.FIRST, SCHEDULE VIRTUAL MEETING.",
        linkname: "LEARN MORE",
    },
];

export const footerlink = [
    {
        title: "QUICK LINK",
        links: [
            {
                name: "HOME",
                link: "/home",
            },
            {
                name: "ABOUT US",
                link: "/about",
            },
            {
                name: "PRODUCT",
                link: "/product",
            },
            {
                name: "BLOG",
                link: "/blog",
            },
            {
                name: "CONTACT",
                link: "/contact",
            },
        ]
    },
    {
        title: "MENU",
        links: [
            {
                name: "PIZZA",
                link: "/home",
            },
            {
                name: "ZINGER BURGER",
                link: "/",
            },
            {
                name: "PASTA",
                link: "/",
            },
            {
                name: "HOT WING",
                link: "/",
            },
            {
                name: "COLD DRINK",
                link: "/",
            },
        ]
    },
    {
        title: "AVAILABLE ON",
        links: [
            {
                name: "MONDAY",
            },
            {
                name: "TUESDAY",
            },
            {
                name: "WEDNESDAY",
            },
            {
                name: "THURSDAY",
            },
            {
                name: "FRIDAY",
            },
        ]
    },
    {
        title: "TIMING",
        links: [
            {
                name: "11-30 : 1-50",
            },
            {
                name: "11-30 : 1-50",
            },
            {
                name: "11-30 : 1-50",
            },
            {
                name: "11-30 : 1-50",
            },
            {
                name: "11-30 : 1-50",
            },
        ]
    },
    {
        title: "CONTACT US",
        links: [
            {
                name: "ADDRESS",
                subname: "PURANI SABAZ MANDI PAKPATTAN"
            },
            {
                name: "EMAIL",
                subname: "gullupizza@gmail.com"
            },
            {
                name: "PHONE",
                subname: "0300 0292619"
            },
        ]
    },
];

export const socialmedia = [
    {
        id: "social-media-1",
        icon: instagram,
        link: "https://www.instagram.com/",
    },
    {
        id: "social-media-2",
        icon: facebook,
        link: "https://www.facebook.com/",
    },
    {
        id: "social-media-3",
        icon: twitter,
        link: "https://www.twitter.com/",
    },
];